const PageContainer = ({children}: {children: React.ReactNode}) => {
    return (
        <div className="grid h-full w-full grid-cols-12 overflow-hidden bg-yellow-40">
            {children}
        </div>
    )
}

export default PageContainer
